/**
 * A chat document's type, as its card labels it: the extension (FILE when it
 * has none) and the colour of the tile it sits on. The messenger's file card
 * (message-bubble.tsx) set these — PDF red, Word blue, Excel green, anything
 * else slate — and the meeting chat's card and its saved .html follow it.
 */
export function documentType(name: string): { ext: string; color: string } {
  const dot = name.lastIndexOf('.')
  const ext = dot > 0 && dot < name.length - 1 ? name.slice(dot + 1).toUpperCase() : 'FILE'
  const color =
    ext === 'PDF' ? '#ef4444'
    : ext === 'DOC' || ext === 'DOCX' ? '#3b82f6'
    : ext === 'XLS' || ext === 'XLSX' ? '#22c55e'
    : '#64748b'
  // The tile holds four letters; a longer extension would spill out of it.
  return { ext: ext.slice(0, 4), color }
}
